import React, { useState, useEffect } from 'react';
import useFormHandler from '../hooks/useFormHandler';
import ClipLoader from 'react-spinners/ClipLoader';
import axios from 'axios';
import Layout from './Layout';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiEndpoint } from "../config.json";


const Formulario = () => {
    const initialFormState = {
        nombre: '',
        telefono: '',
        correo: '',
        tipoInquietud: '',
        planteamiento: '',
        sugerenciaMejora: ''
    }

    const [form, setForm, handleInputChange, handleFormSubmit] = useFormHandler(initialFormState, submitForm);

    const [validation, setValidation] = useState({});
    const [dateString, setDateString] = useState("");
    const [intervalVariable, setIntervalVariable] = useState(null);
    const [sendingForm, setSendingFormStatus] = useState(false);


    useEffect(() => {
        toast.configure();
        const getDateStr = () => {
            const dt = new Date();
            return dt.toLocaleString('es-DO');
        }
        setDateString(getDateStr());
        const interval = setInterval(() => {
            setDateString(getDateStr());
        }, 1000);
        setIntervalVariable(interval);
    }, [])

    async function submitForm(formState) {
        if (!validate()) return;
        setSendingFormStatus(true);

        const url = `${apiEndpoint}/v1/postformulario";`;
        const result = await axios.post(url, formState);
        setSendingFormStatus(false);

        if (result.status === 200) {
            clearTimeout(intervalVariable);
            toast.success("Mensaje enviado de forma satisfactoria");
            return true;
        }
        toast.error("Falló el envío del mensaje");
        return false;
    }

    function validate() {
        const frm = { ...form };
        const v = {};
        setValidation(v);//reset all

        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const validateEmail = email => re.test(email);

        if (frm.correo.length > 0) {
            if (!validateEmail(frm.correo)) {
                v.correo = "Debe proporcionar un correo válido";
            }
        }
        if (frm.tipoInquietud.length === 0) {
            v.tipoInquietud = "Debe escoger una opción";
        }
        if (frm.planteamiento.length === 0) {
            v.planteamiento = "Debe escribir su planteamiento";
        }
        if (frm.tipoInquietud === "queja" && frm.sugerenciaMejora.length === 0) {
            v.sugerenciaMejora = "Le animamos a escribir su sugerencia de mejora";
        }

        setValidation(v);
        return Object.keys(v).length === 0;
    }

    const handleCheck = (name, value) => {
        setForm({ ...form, [name]: value });
    }

    return (
        <Layout>
            <h1 className="mb-4 pr-3 font-weight-bold">Exprésanos tus inquietudes y sugerencias</h1>
            <div className="card mb-3">
                <div className="card-header pb-1 border-0">
                    <div className="row justify-content-between">
                        <div className="col-lg-3 col-md-4 col-sm-12 mb-3">
                            <h6 className="mb-3 pt-1 pb-2 border-bottom"> Fecha:</h6>
                            <div className="white-box">
                                {dateString}
                            </div>
                        </div>
                        <div className="col-lg-9 col-md-8 col-sm-12">
                            <h6 className="mb-3 pt-1 pb-2 border-bottom">Seleccione el tipo de inquietud:</h6>                            
                            <div className="row">
                                <div className="col-lg col-sm-auto radio-box mb-3 pr-sm-0 pr-3">
                                    <input type="radio" name="tipoInquietud" id="idea" checked={form.tipoInquietud === "idea"} onChange={() => handleCheck("tipoInquietud", "idea")} value={form.tipoInquietud} />
                                    <label className="radio-box" htmlFor="idea">Idea</label>
                                </div>
                                <div className="col-lg col-sm-auto radio-box mb-3 pr-sm-0 pr-3">
                                    <input type="radio" name="tipoInquietud" id="sugerencia" checked={form.tipoInquietud === "sugerencia"} onChange={() => handleCheck("tipoInquietud", "sugerencia")} value={form.tipoInquietud} />
                                    <label htmlFor="sugerencia">Sugerencia</label>
                                </div>
                                <div className="col-lg col-sm-auto radio-box mb-3 pr-sm-0 pr-3">
                                    <input type="radio" name="tipoInquietud" id="reconocimiento" checked={form.tipoInquietud === "reconocimiento"} onChange={() => handleCheck("tipoInquietud", "reconocimiento")} value={form.tipoInquietud} />
                                    <label htmlFor="reconocimiento">Reconocimiento</label>
                                </div>
                                <div className="col-lg col-sm-auto radio-box mb-3 pr-sm-3 pr-3">
                                    <input type="radio" name="tipoInquietud" id="queja" checked={form.tipoInquietud === "queja"} onChange={() => handleCheck("tipoInquietud", "queja")} value={form.tipoInquietud} />
                                    <label htmlFor="queja">Queja</label>
                                </div>
                                <div className="col-lg col-sm-auto radio-box mb-3">
                                    <input type="radio" name="tipoInquietud" id="denuncia" checked={form.tipoInquietud === "denuncia"} onChange={() => handleCheck("tipoInquietud", "denuncia")} value={form.tipoInquietud} />
                                    <label htmlFor="denuncia">Denuncia</label>
                                </div>
                            </div>                            
                                {validation.tipoInquietud && <div className="row mb-3"><div className="col"><span className="text-danger">{validation.tipoInquietud}.</span></div></div>}                                
                        </div>
                    </div>
                </div>
            </div>
            <div className="card mb-3">
                <div className="card-header">
                    <h6 className="mb-0">Información del Remitente <small> (No obligatoria)</small></h6>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-5 col-sm-12 pr-md-0 pr-3 form-group">
                            <label htmlFor="nombre">Nombre</label>
                            <input type="text" className="form-control" name="nombre" id="nombre" onChange={handleInputChange} value={form.nombre} />
                        </div>
                        <div className="col-md-3 col-sm-6 pr-sm-0 pr-3 form-group">
                            <label htmlFor="telefono">Teléfono</label>
                            <input type="telephone" className="form-control" name="telefono" id="telefono" onChange={handleInputChange} value={form.telefono} />
                        </div>
                        <div className="col-md-4 col-sm-6 form-group">
                            <label htmlFor="telefono">Correo</label>
                            <input type="email" className="form-control" name="correo" id="correo" onChange={handleInputChange} value={form.correo} />
                            {validation.correo && <p className="text-danger mt-3 mb-0">{validation.correo}</p>}
                        </div>                       
                    </div>                   
                </div>               
            </div>
            <div className="card mb-3">
                <div className="card-header">
                <h6 className="m-0">Planteamiento</h6>
                </div>
                    <div className="card-body">
                    <textarea name="planteamiento" id="planteamiento" className="form-control" rows="4" value={form.planteamiento} onChange={handleInputChange}></textarea>
                            {validation.planteamiento && <p className="text-danger mt-3 mb-0">{validation.planteamiento}.</p>}                    
                    </div>                    
                </div>
                {form.tipoInquietud === "queja" && <div className="card mb-3">
                    <div className="card-header">
                        <h6 className="m-0">Ideas para mejorar</h6>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-lg-12">                            
                                <textarea name="sugerenciaMejora" id="sugerenciaMejora" className="form-control" rows="4" value={form.sugerenciaMejora} onChange={handleInputChange}></textarea>
                                {validation.sugerenciaMejora && <p className="text-danger mt-3 mb-0">{validation.sugerenciaMejora}.</p>}
                            </div>
                        </div>
                    </div>
                </div>}
                <div className="text-right">
                {sendingForm ?
                        <ClipLoader color={'#007bff'} /> :
                        <button className="btn btn-success px-3 text-uppercase mb-5" onClick={handleFormSubmit}>                            
                            <i className="fas fa-paper-plane pr-3"></i>Enviar
                            
                    </button>}
                </div>
        </Layout>
    );
}

export default Formulario;
